<button class="reset" (click)="reset()"
        *ngIf="control.value">
  <mat-icon>close</mat-icon>
</button>
